import { RESET_MESSAGE_FILTERS, SET_MESSAGES_FILTER_TEXT, TOGGLE_MESSAGES_FILTER } from '../../reducers/conversations/chat/messageFilters'

import { apiConversation } from '../../../api'
import { setMessagesWithFilters } from './messagesAct'

const conversationsApi = apiConversation.conversations

export const toggleFilter = (userId, filter) => ({ userId, filter, type: TOGGLE_MESSAGES_FILTER })
export const setFilterText = (userId, filterText) => ({
  userId,
  filterText,
  type: SET_MESSAGES_FILTER_TEXT,
})
export const resetMessageFilters = (userId) => (dispatch) => dispatch({ userId, type: RESET_MESSAGE_FILTERS })

/**
 * Set user unread messages count.
 *
 * @param {String} user User public ID
 * @param {String} filter Filter name
 */
export const toggleMessageFilter = (user, filter) => (dispatch) => dispatch(toggleFilter(user, filter))

export const getFilteredMessages = ({ user = {}, filterTypes = {}, text = '', subjectId, eventType }) => (dispatch) => {
  conversationsApi
    .getMessages({ userId: user.id, filterTypes, text, subjectId, eventType })
    .then(({ data, status }) => {
      if (status === 200) {
        const { messages: newMessages, user: userId } = data

        if (newMessages.length > 0 && newMessages.length < 25) newMessages[newMessages.length - 1].firstMessage = true

        dispatch(setMessagesWithFilters(userId, newMessages))
      } else {
        dispatch(setMessagesWithFilters(user.id, []))
      }
    })
    .catch(console.error)
}

export default {
  toggleMessageFilter,
  resetMessageFilters,
  setFilterText,
  getFilteredMessages,
}
